import { render, staticRenderFns } from "./Go.vue?vue&type=template&id=e6e42194&"
import script from "./Go.vue?vue&type=script&lang=js&"
export * from "./Go.vue?vue&type=script&lang=js&"
import style0 from "./Go.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports